<template>
  <section
    id="page"
    class="main-content-wrapper"
    :class="formStyleClasses"
    :style="{'padding-top': formFramePaddingTop}"
  >
    <template v-if="1 || !loading && $store.getters.getFormSchema(idWndw).id">
      <slot name="formHeader"></slot>
      <loading v-if="loading"></loading>
      <form-gen
        v-if="!loading && $store.getters.getFormSchema(idWndw).id"
        ref="formGen"
        :key="_uid"
        :form-source="$store.getters.getFormSchema(idWndw)"
        :loading="loading"
        :id-wndw="idWndw"
      >
      </form-gen>

      <slot name="formFooter"></slot>
    </template>
  </section>
</template>

<script>
    import {
        formService
    }
    from 'Js/feathers'
    // import _ from 'lodash'
    import { EventBus } from 'Js/eventBus';
    import router from 'Js/routes.js';
    import { getQueryParams } from 'Js/bfUtilities';
    import { TranslateJSON } from 'Js/bfUtilities';
    const { buildFormRequestQuery } = require('Js/formRequestQuery');
    Vue.component('form-gen', require('./formGen/formgen.vue').default);
    import store from 'Js/store'
    import siteModule from 'Js/store/modules/site.js';
    import { shouldUseCachedForm } from 'Js/formCachePolicy';
    import { shouldUseGlobalSchemaLayout, resolveFormFramePaddingTop } from 'Js/globalSchemaLayout.js';

    const edit2DiagStartedAt = typeof performance !== 'undefined' ? performance.now() : 0;

    function sendEdit2BootDiag(stage, details = {}) {
        if (typeof window === 'undefined' || new URLSearchParams(window.location.search).get('_bfEdit2Diag') !== '1') return;
        try {
            window.parent.postMessage(JSON.stringify({
                __bfEdit2Diag: true,
                stage,
                elapsedMs: typeof performance !== 'undefined' ? Math.round(performance.now() - edit2DiagStartedAt) : 0,
                details
            }), '*');
        } catch (e) {
            return;
        }
    }
    
    export default {

        name: "Form-Frame",

        methods: {
            fetchForm: function(id) {
                var _this = this, navSlug = getFormNavSlug(id), fetchingNetwork = false;
                sendEdit2BootDiag('boot:form-fetch:start', {
                    hasId: Boolean(id),
                    hasNavSlug: Boolean(navSlug),
                    siteLoaded: this.$store.state.site.loaded,
                    stateOnline: this.$store.state.site.isOnline
                });
                
                // STEP 9: SSR HYDRATION - Check for server-rendered form data
                if (window.__INITIAL_STATE__ && window.__INITIAL_STATE__.formModel && window.__INITIAL_STATE__.formModel.form) {
                    console.log('[SSR Hydration] Using server-rendered form model for:', id);
                    const formModel = window.__INITIAL_STATE__.formModel;
                    
                    // Process the form the same way as network-fetched data
                    return new Promise((resolve, reject) => {
                        try {
                            let result = BF.convertToVFG3(formModel);
                            result.model = JSON.parse(JSON.stringify(formModel.model));
                            
                            // Save to localStorage for future offline use
                            navSlug && !formModel.form.requestHook ? setFormLocally(navSlug, result) : null;
                            
                            let translateResult = TranslateJSON(result, _this.idWndw);
                            var resultSetSiteApp = setSiteApp(_this, translateResult);
                            loadForm(_this, resultSetSiteApp);
                            
                            // Clean up - but keep window.__INITIAL_STATE__ until site model is also consumed
                            if (!window.__INITIAL_STATE__.siteModel) {
                                delete window.__INITIAL_STATE__;
                            } else {
                                delete window.__INITIAL_STATE__.formModel;
                            }
                            
                            resolve(resultSetSiteApp);
                        } catch (e) {
                            console.error('[SSR Hydration] Failed to process form:', e);
                            reject(e);
                        }
                    });
                }
                
                // Normal CSR flow (no SSR)
                // if there is a JWT around try to auth it before the call.
                sendEdit2BootDiag('boot:form-auth:start');
                return new Promise((resolve, reject) => this.$store.dispatch('CHECK_AUTH', true)
                    .then(async () => {
                        let params = {};
                        _this.$store.dispatch('ACTIONS_PAUSE', true);
                        params.query = buildFormRequestQuery({
                            layouts: _this.$store.state.site.content.layouts,
                            routePath: _this.$route.path,
                            explicitQuery: _this.query,
                            searchQuery: getQueryParams()
                        });
                        
                        const isOnline = store.getters.isOnline();
                        const isAuthenticated = store.getters.isAuthenticated();
                        sendEdit2BootDiag('boot:form-auth:end', {
                            isOnline,
                            isAuthenticated
                        });
                        
                        // Check if form is cached locally
                        if (navSlug && isFormLocal(navSlug)) {
                            const formSchema = getCachedFormSchema(navSlug);
                            if (!formSchema) {
                                sendEdit2BootDiag('boot:form-fetch:empty-cache-exit');
                                return;
                            }
                            const authLevel = formSchema.form.authLevel;
                            const requestHook = formSchema.form.requestHook;
                            
                            if (shouldUseCachedForm({ authLevel, requestHook, isOnline, isAuthenticated })) {
                                sendEdit2BootDiag('boot:form-fetch:cache-hit');
                                return formSchema;
                            }
                            
                            // Cache exists but not usable due to auth requirement - redirect to login
                            if (authLevel === 1 && isOnline && !isAuthenticated) {
                                router.push('/login?redirect=' + encodeURIComponent(router.currentRoute.fullPath));
                                return; // Return undefined to stop chain gracefully
                            }
                        }
                        
                        if (isOnline) {
                            fetchingNetwork = true;
                            sendEdit2BootDiag('boot:form-request:start');
                            return formService.get(id, params);
                        }
                        
                        sendEdit2BootDiag('boot:form-fetch:offline');
                        console.log('@formFetch site is offline')
                        throw {
                            name: 'Unavailable',
                            message: 'Check your internet connection.',
                            code: 10902,
                            className: 'User Offline'
                        };
                    })
                    .then(result => {
                        if (!result) {
                            sendEdit2BootDiag('boot:form-fetch:empty-result-exit');
                            return; // Graceful exit from login redirect
                        }
                        sendEdit2BootDiag('boot:form-request:end', {
                            fetchedFromNetwork: fetchingNetwork
                        });
                        
                        //if online - save it to LS
                        let resultClone = JSON.parse(JSON.stringify(result));
                        result = BF.convertToVFG3(result);
                        
                        result.model = JSON.parse(JSON.stringify(resultClone.model));
                        navSlug && _this.$store.getters.isOnline() && fetchingNetwork && !result.form.requestHook ? setFormLocally(navSlug, result) : null;
                        let translateResult = TranslateJSON(result, _this.idWndw);
                        
                        var resultSetSiteApp = setSiteApp(_this, translateResult);
                        
                        loadForm(_this, resultSetSiteApp);
                    })
                    .catch(e => {
                        if (!e) return; // Graceful exit
                        sendEdit2BootDiag('boot:form-fetch:error', {
                            name: e && e.name || typeof e,
                            code: e && e.code || null,
                            className: e && e.className || null,
                            stateOnline: store.getters.isOnline()
                        });
                        
                        const onlineNow = store.getters.isOnline();
                        if (e.message === 'No record found for id anonymous') {
                            window.localStorage.removeItem('feathers-jwt');
                            location.reload();
                            return;
                        }
                        
                        // Network 401 while online → redirect to login
                        if (e.code === 401 && onlineNow) {
                            router.push('/login?redirect=' + encodeURIComponent(router.currentRoute.fullPath));
                            return;
                        }
                        
                        if (e.code == 401 && this.$store.state.wndw.windows.length > 1) {
                            EventBus.$emit("hideCardModal", {});
                        }
                        
                        if (e.code == 404) {
                            return new Promise((resolve, reject) => {
                                var bfops = readBfSiteCache();
                                var hash = bfops && bfops.siteJSON && bfops.siteJSON.hash || '';
                                // If the site hash didn't change, the loader resolves instead of reloading.
                                // Mirror router missing-slug behavior by surfacing a system error.
                                const onResolved = () => {
                                    BF.errorThrow(404, `Page not found for form id: ${id}`, 'Path Not Found.');
                                    resolve();
                                };
                                siteModule.loadSiteFromNetwork(onResolved, reject, hash);
                            })
                        }
                        
                        BF.errorThrow(e);
                    })
                );
            }
        },

        mounted() {
            // fetches form based on passed slug prop or routePath
            // TODO trap for bad form data
            let slug = this.urnSlug || this.$route.params.urnSlug
            if (slug) {
                let id = this.$store.state.site.content.layouts[slug].id
                this.fetchForm(id);
            }
            else {
                this.fetchForm(this.id);
            }
        },

        created() {},

        beforeMount() {},

        beforeDestroy() {},

        destroyed() {},
        
        computed: {
            formStyleClasses: function() {
                return this.loading ? '' : this.formSchema.form.styleClassesPage || 'flex-1'
            },
            formFramePaddingTop: function() {
                return resolveFormFramePaddingTop({
                    idWndw: this.idWndw,
                    showTopNavBar: this.$store.getters.showTopNavBar,
                    useGlobalSchemaLayout: shouldUseGlobalSchemaLayout(
                        this.$store.state.site.content,
                        null,
                        this.$store.state.site.globalSchemaTestMode
                    )
                });
            }
        },
        
        watch: {
            formSchema: {
                handler() {
                },
                deep: true
            }

        },

        props: {
            id: String,
            storePath: String,
            urnSlug: String,
            idWndw: {
                type: Number,
                default: 0
            },
            model: null,
            query: null,
        },

        data: function() {
            return {
                formSchema: {},
                loading: true
            }
        }

    }
    
    function setSiteApp(_this, result) {
        if (result.code) { throw result }
        if (result.site) { _this.$store.commit('SET_SITE', result.site) }
        _this.$store.commit('SET_APP', result.app );
        delete result.app
        delete result.error;
        return result
    }
    
    function loadForm (_this, result) {
        sendEdit2BootDiag('boot:form-load:start', {
            hasResult: Boolean(result),
            actionsPaused: _this.$store.state.actions.isPaused
        });
        
        result.options.idWndw = _this.idWndw 
        result.options.devMode = !!_this.$store.state.site.content.devMode
        _this.idWndw ? result.model = Object.assign(result.model, _this.model) : null
        
        _this.$store.dispatch('UPDATE_WINDOW', {
            id: result.options.idWndw,
            formSchema: result
        });
        sendEdit2BootDiag('boot:form-window-updated', {
            windows: _this.$store.state.wndw.windows.length
        });
        
        var pendingThreads = _this.$store.getters.pendingThreads;
        if (pendingThreads.length) {
            pendingThreads.forEach(idThread => {
                _this.$store.dispatch('ACTIONS_QUEUE', {idThread});
            });
            _this.$store.commit('CLEAR_PENDINGTHREADS');
        }
        
        _this.$store.dispatch('ACTIONS_QUEUE', result.actions); // added by script service
        delete result.actions
        if (_.get(result, 'form.namedActions.onFormLoad')) {
            _this.$store.dispatch('ACTIONS_QUEUE', result.form.namedActions.onFormLoad); // onFormLoad
        }
        _this.formSchema = result
        result.state ? null : result.state = {}
        _this.loading = false
        _this.$store.dispatch('ACTIONS_PAUSE', false );
        sendEdit2BootDiag('boot:form-actions-unpaused', {
            hasOnFormLoad: Boolean(_.get(result, 'form.namedActions.onFormLoad')),
            windows: _this.$store.state.wndw.windows.length
        });
    }
    
    function getFormNavSlug (formId) {
        var localBfSiteObj = readBfSiteCache();
        var layouts = localBfSiteObj && localBfSiteObj.siteJSON && localBfSiteObj.siteJSON.content && localBfSiteObj.siteJSON.content.layouts;
        if (layouts) {
            for (const [key, value] of Object.entries(layouts)) {
                if (value.id === formId) return key;
            }
        }
        return undefined;
    }
    
    function setFormLocally (navSlug, form) {
        var localBfSite = readBfSiteCache();
        if (!localBfSite || !localBfSite.siteJSON || !localBfSite.siteJSON.content || !localBfSite.siteJSON.content.layouts) {
            return false;
        }
        _.set(localBfSite.siteJSON.content.layouts[navSlug], 'formSchema', form);
        try {
            window.localStorage.setItem('_bfsite', JSON.stringify(localBfSite));
            return true;
        } catch (e) {
            BF.errorThrow (10171, `Unable to add the formSchema for navSlug '${navSlug}'`, 'Error encountered while attempting to write data to local or session storage.');
            return false;
        }
    }
    
    function isFormLocal (navSlug) {
        if (getCachedFormSchema(navSlug)) return true;
        return false;
    }

    function getCachedFormSchema (navSlug) {
        var layout = getCachedLayout(navSlug);
        return layout && layout.formSchema;
    }

    function getCachedLayout (navSlug) {
        var bfsite = readBfSiteCache();
        return bfsite && bfsite.siteJSON && bfsite.siteJSON.content && bfsite.siteJSON.content.layouts && bfsite.siteJSON.content.layouts[navSlug];
    }

    function readBfSiteCache () {
        try {
            var raw = window.localStorage.getItem('_bfsite');
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }
    
</script>

<style>
</style>
